import { useCallback } from "react";
import { useKeycloak } from "@react-keycloak/web";
import { keycloak } from "../keycloak";
// You must export your Keycloak instance from somewhere

const HTTP_NO_CONTENT = 204;
const HTTP_RESET_CONTENT = 205;

export async function fetchGlobal<T>(
    url: string,
    options: RequestInit = {}
): Promise<T> {
    try {
        let token: string | undefined;
        setTimeout(() => {}, 3000);
        if (keycloak?.authenticated) {
            token = keycloak?.token;
        }

        if (!token) {
            token = localStorage.getItem("token") || undefined;
        }

        if (token) {
            options.headers = {
                ...options.headers,
                Authorization: `Bearer ${token}`,
            };
        }

        const response = await fetch(url, options);

        if (!response.ok) {
            throw new Error(`HTTP ${response.status} – ${response.statusText}`);
        }

        const data: T = await response.json();
        return data;
    } catch (error) {
        console.error("Erreur dans fetchGlobal:", error);
        throw error;
    }
}
export function useFetchGlobal() {
    const { keycloak } = useKeycloak();

    /**
     * @returns parsed JSON body typed as T, or `undefined` when the response
     * status is 204/205 (No Content / Reset Content). Callers awaiting a
     * non-nullable shape must handle that case.
     */
    const fetchWithKC = useCallback(
        async <T>(url: string, options: RequestInit = {}): Promise<T> => {
            if (keycloak?.token) {
                options.headers = {
                    ...options.headers,
                    Authorization: `Bearer ${keycloak.token}`,
                };
            }

            const r = await fetch(url, options);
            if (!r.ok) throw new Error("HTTP error");

            if (
                r.status === HTTP_NO_CONTENT ||
                r.status === HTTP_RESET_CONTENT
            ) {
                return undefined as T;
            }

            try {
                return (await r.json()) as T;
            } catch (e) {
                throw new Error(`Invalid JSON response from ${url}`, {
                    cause: e,
                });
            }
        },
        [keycloak]
    );

    return { fetchGlobal: fetchWithKC };
}
